/* ==========================================================================
   JokeyJoy Theme 2026 — theme.js
   Dependency-free behaviours ported from the Home v4 mockup's runtime:
   mega-menu (desktop hover + keyboard), mobile nav, weekend countdown,
   WhatsApp chat popup, cart count, header scroll shadow. Declarative via
   data-* attributes so every page shares one contract.
   ========================================================================== */
(function () {
  'use strict';
  var $  = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var pad = function (n) { return (n < 10 ? '0' : '') + n; };

  /* ---- Generic overlay open/close (mobile nav, chat) --------------------- */
  function open(el){ if(el){ el.classList.add('is-open'); el.setAttribute('aria-hidden','false'); } }
  function close(el){ if(el){ el.classList.remove('is-open'); el.setAttribute('aria-hidden','true'); } }
  function toggle(el){ if(!el) return; el.classList.contains('is-open') ? close(el) : open(el); }

  // [data-open="#id"] / [data-close] / [data-toggle="#id"]
  $$('[data-open]').forEach(function (b) { b.addEventListener('click', function (e) { e.preventDefault(); open($(b.getAttribute('data-open'))); if($(b.getAttribute('data-open')) && $(b.getAttribute('data-open')).classList.contains('jj-mobile-nav')) document.documentElement.style.overflow='hidden'; }); });
  $$('[data-toggle]').forEach(function (b) { b.addEventListener('click', function (e) { e.preventDefault(); toggle($(b.getAttribute('data-toggle'))); }); });
  $$('[data-close]').forEach(function (b) { b.addEventListener('click', function () { var host=b.closest('.jj-mobile-nav,.jj-chat,.jj-drawer'); close(host); document.documentElement.style.overflow=''; }); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { $$('.jj-mobile-nav.is-open,.jj-drawer.is-open').forEach(function(el){close(el);document.documentElement.style.overflow='';}); } });
  $$('.jj-mobile-nav__overlay,.jj-drawer__overlay').forEach(function(o){ o.addEventListener('click', function(){ close(o.closest('.jj-mobile-nav,.jj-drawer')); document.documentElement.style.overflow=''; }); });

  /* ---- Header scroll shadow ---------------------------------------------- */
  var header = $('.jj-header');
  if (header) { var onS=function(){ header.classList.toggle('is-scrolled', window.scrollY>6); }; window.addEventListener('scroll',onS,{passive:true}); onS(); }

  /* ---- Weekend countdown --------------------------------------------------
     [data-countdown="ISO"] with children [data-cd="hrs|min|sec"] (or days). -- */
  function autoSunday(){ var n=new Date(); var t=new Date(n); t.setDate(n.getDate()+((7-n.getDay())%7||7)); t.setHours(23,59,59,0); return t.getTime(); }
  $$('[data-countdown]').forEach(function (root) {
    var raw = root.getAttribute('data-countdown');
    var target = raw === 'auto-sunday' ? autoSunday() : new Date(raw).getTime();
    if (isNaN(target)) return;
    var elh=$('[data-cd="hrs"]',root), elm=$('[data-cd="min"]',root), els=$('[data-cd="sec"]',root), eld=$('[data-cd="days"]',root), elw=$('[data-cd="days-wrap"]',root);
    function tick(){
      var diff=target-Date.now(); if(diff<0)diff=0;
      var d=Math.floor(diff/86400000);
      if(eld) eld.textContent=d;
      if(elw) elw.style.display=d>0?'':'none';
      if(elh) elh.textContent=pad(eld?Math.floor(diff/3600000)%24:Math.floor(diff/3600000));
      if(elm) elm.textContent=pad(Math.floor(diff/60000)%60);
      if(els) els.textContent=pad(Math.floor(diff/1000)%60);
    }
    tick(); setInterval(tick,1000);
  });

  /* ---- Cart count (demo add-to-cart) ------------------------------------- */
  var countEls=$$('[data-cart-count]');
  function setCount(n){ countEls.forEach(function(el){ el.textContent=el.getAttribute('data-cart-fmt') ? el.getAttribute('data-cart-fmt').replace('%',n) : n; }); }
  var cart=0;
  $$('[data-add]').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault(); cart++; setCount(cart);
      btn.animate([{transform:'scale(1)'},{transform:'scale(.96)'},{transform:'scale(1)'}],{duration:200,easing:'ease'});
    });
  });

  /* ---- PDP / level tabs, qty steppers (progressive) ---------------------- */
  $$('[data-qty]').forEach(function (wrap) {
    var out=$('[data-qty-value]',wrap);
    var isInput = out && (out.tagName==='INPUT');
    var readV = function(){ return parseInt(isInput?out.value:out.textContent,10)||1; };
    var writeV = function(v){ v=v<1?1:v; if(isInput){out.value=v;} else {out.textContent=v;} };
    wrap.addEventListener('click', function(e){ var s=e.target.closest('[data-qty-step]'); if(!s||!out) return; writeV(readV()+parseInt(s.getAttribute('data-qty-step'),10)); });
  });
  $$('[data-tabs]').forEach(function (group) {
    group.addEventListener('click', function (e) {
      var t=e.target.closest('[data-tab]'); if(!t) return;
      $$('[data-tab]',group).forEach(function(x){x.classList.remove('is-active');});
      t.classList.add('is-active');
      var panelSel=t.getAttribute('data-tab'); var scope=document.querySelector(group.getAttribute('data-tabs'))||document;
      $$('[data-panel]',scope).forEach(function(p){ p.style.display = p.getAttribute('data-panel')===panelSel ? '' : 'none'; });
    });
  });
})();

/* ---- Announcement rotate + Mobile sticky ATC (JokeyJoy phase-3) ---------- */
(function(){
  'use strict';
  var $$=function(s,r){return Array.prototype.slice.call((r||document).querySelectorAll(s));};
  // Rotating announcement messages
  $$('[data-announce-rotate]').forEach(function(bar){
    var msgs=$$('.jj-announce-msg',bar); if(msgs.length<2) return;
    var i=0, sp=(parseFloat(bar.getAttribute('data-announce-rotate'))||4)*1000;
    msgs.forEach(function(m,x){ m.classList.toggle('is-active',x===0); });
    setInterval(function(){ msgs[i].classList.remove('is-active'); i=(i+1)%msgs.length; msgs[i].classList.add('is-active'); }, sp);
  });
  // Mobile sticky ATC — reveal when the main Add button scrolls out of view
  var sticky=document.querySelector('[data-sticky-atc]');
  var mainBtn=document.querySelector('#pdp-form [name="add"], .jj-pdp-add');
  if(sticky && mainBtn && 'IntersectionObserver' in window){
    var io=new IntersectionObserver(function(entries){
      entries.forEach(function(e){ sticky.classList.toggle('is-visible', !e.isIntersecting); });
    },{rootMargin:'0px 0px -20% 0px'});
    io.observe(mainBtn);
  }
})();

/* ---- PDP variant selector (physical / digital / editions) ---------------- */
(function(){
  'use strict';
  var box=document.querySelector('[data-variants]');
  var json=document.querySelector('[data-variant-json]');
  if(!box||!json) return;
  var variants; try{ variants=JSON.parse(json.textContent); }catch(e){ return; }
  var groups=Array.prototype.slice.call(box.querySelectorAll('[data-variant-group]'));
  function selected(){ return groups.map(function(g){ var a=g.querySelector('.jj-variant-opt.is-active'); return a?a.getAttribute('data-value'):null; }); }
  function match(sel){ for(var i=0;i<variants.length;i++){ var o=variants[i].options||[]; var ok=true; for(var j=0;j<sel.length;j++){ if(String(o[j])!==String(sel[j])){ok=false;break;} } if(ok) return variants[i]; } return null; }
  function apply(v){
    if(!v) return;
    document.querySelectorAll('input[name="id"]:not([data-cart-offer-id])').forEach(function(i){ i.value=v.id; });
    var p=document.querySelector('[data-price]'); if(p) p.textContent=v.price;
    var ap=document.querySelector('[data-atc-price]'); if(ap) ap.textContent=v.price;
    var c=document.querySelector('[data-compare]'); if(c){ if(v.on_sale){ c.textContent=v.compare; c.style.display=''; } else { c.style.display='none'; } }
    document.querySelectorAll('[data-atc-btn]').forEach(function(b){
      b.disabled=!v.available;
      var add=b.getAttribute('data-label-add'), sold=b.getAttribute('data-label-sold');
      if(b.querySelector('[data-atc-price]')){ b.firstChild&&(b.childNodes[0].nodeValue=v.available?(add+' — '):sold); if(!v.available){ b.textContent=sold; } }
      else { b.textContent=v.available?add:sold; }
    });
  }
  box.addEventListener('click',function(e){
    var btn=e.target.closest('.jj-variant-opt'); if(!btn) return;
    var g=btn.closest('[data-variant-group]');
    g.querySelectorAll('.jj-variant-opt').forEach(function(x){ x.classList.remove('is-active'); });
    btn.classList.add('is-active');
    apply(match(selected()));
  });
})();

/* ---- On-card variant switcher (collection grid, digital / physical) ------- */
(function(){
  'use strict';
  document.addEventListener('click',function(e){
    var btn=e.target.closest('.jj-card__vopt'); if(!btn) return;
    var card=btn.closest('.jj-card'); if(!card) return;
    var group=btn.closest('[data-card-variants]');
    group.querySelectorAll('.jj-card__vopt').forEach(function(x){ x.classList.remove('is-active'); });
    btn.classList.add('is-active');
    var jsonEl=card.querySelector('[data-card-variant-json]'); if(!jsonEl) return;
    var variants; try{ variants=JSON.parse(jsonEl.textContent); }catch(err){ return; }
    var val=btn.getAttribute('data-value'), v=null;
    for(var i=0;i<variants.length;i++){ if(String(variants[i].o)===String(val)){ v=variants[i]; break; } }
    if(!v) return;
    var idInput=card.querySelector('[data-card-id]'); if(idInput) idInput.value=v.id;
    var priceEl=card.querySelector('[data-card-price]'); if(priceEl) priceEl.innerHTML=v.p;
    var cta=card.querySelector('.jj-card__cta'); if(cta && !cta.classList.contains('jj-card__cta--soldout')) cta.disabled=!v.a;
  });
})();

/* ---- AJAX add-to-cart → opens the cart drawer + live refresh -------------- */
(function(){
  var drawer=document.querySelector('[data-cart-drawer]');
  function money(c){ return 'EGP ' + Math.round(c/100).toLocaleString('en'); }
  function esc(value){
    return String(value==null?'':value).replace(/[&<>'"]/g,function(ch){ return {'&':'&amp;','<':'&lt;','>':'&gt;',"'":'&#39;','"':'&quot;'}[ch]; });
  }
  function openDrawer(){ if(drawer){ drawer.classList.add('is-open'); drawer.setAttribute('aria-hidden','false'); } }

  function itemHTML(it){
    var key=esc(it.key), title=esc(it.product_title), url=esc(it.url);
    var img=it.image?'<img class="jj-ci__image" src="'+esc(it.image)+'" alt="'+title+'" loading="lazy">':'<span aria-hidden="true">□</span>';
    var variant=(it.variant_title&&it.variant_title.indexOf('Default')===-1)?'<span class="jj-ci__variant">'+esc(it.variant_title)+'</span>':'';
    return '<article class="jj-ci" data-cart-line="'+key+'" data-cart-product="'+esc(it.product_id)+'">'+
      '<a class="jj-ci__media" href="'+url+'" aria-label="'+title+'">'+img+'</a>'+
      '<div class="jj-ci__info"><a class="jj-ci__title" href="'+url+'">'+title+'</a>'+variant+
      '<div class="jj-ci__bottom"><div class="jj-ci__qty" aria-label="Quantity">'+
      '<button type="button" data-cart-qty="'+key+'" data-qty="'+it.quantity+'" data-delta="-1" aria-label="Decrease quantity">−</button><span>'+it.quantity+'</span>'+
      '<button type="button" data-cart-qty="'+key+'" data-qty="'+it.quantity+'" data-delta="1" aria-label="Increase quantity">+</button></div>'+
      '<strong class="jj-ci__price">'+money(it.final_line_price)+'</strong></div></div>'+
      '<button class="jj-ci__remove" type="button" data-cart-remove="'+key+'" aria-label="Remove '+title+'">×</button></article>';
  }
  function freeshipHTML(total){
    var thr = drawer ? parseInt(drawer.getAttribute('data-freeship-threshold'),10)||0 : 0;
    var iconTemplate = drawer ? drawer.querySelector('[data-freeship-icon]') : null;
    var icon = iconTemplate ? iconTemplate.innerHTML : '';
    if(thr<=0) return '';
    if(total>=thr) return '<div class="jj-freeship jj-freeship--done"><span class="jj-freeship__message"><span class="jj-freeship__icon" aria-hidden="true">'+icon+'</span><span><b>التوصيل المجاني اتفعّل.</b> أوردرك جاهز للطريق.</span></span><span class="jj-freeship__track"><span class="jj-freeship__bar" style="width:100%;"></span></span></div>';
    var pct=Math.min(100,Math.round(total/thr*100));
    return '<div class="jj-freeship"><span class="jj-freeship__message"><span class="jj-freeship__icon" aria-hidden="true">'+icon+'</span><span>ضيف <b>'+money(thr-total)+'</b> وتوصيلك يبقى مجاني</span></span><span class="jj-freeship__track"><span class="jj-freeship__bar" style="width:'+pct+'%;"></span></span></div>';
  }
  function paintCount(n){
    var b=document.querySelector('[data-cart-count-badge]'); if(b){ b.textContent=n; b.classList.toggle('is-on',n>0); }
    var h=document.querySelector('[data-cart-count-h]'); if(h){ h.textContent='('+n+')'; }
    document.querySelectorAll('[data-cart-count]').forEach(function(el){ el.textContent=n; });
  }
  function render(cart){
    paintCount(cart.item_count);
    if(!drawer) return;
    var items=drawer.querySelector('[data-cart-items]'), empty=drawer.querySelector('[data-cart-empty]'), foot=drawer.querySelector('[data-cart-foot]'), offers=drawer.querySelector('[data-cart-offers]'), fs=drawer.querySelector('[data-freeship]'), sub=drawer.querySelector('[data-cart-subtotal]');
    if(cart.item_count>0){
      if(items){ items.innerHTML=cart.items.map(itemHTML).join(''); items.hidden=false; }
      if(empty) empty.hidden=true;
      if(foot) foot.hidden=false;
      if(offers) offers.hidden=false;
    } else {
      if(items){ items.innerHTML=''; items.hidden=true; }
      if(empty) empty.hidden=false;
      if(foot) foot.hidden=true;
      if(offers) offers.hidden=true;
    }
    if(fs) fs.innerHTML=freeshipHTML(cart.total_price);
    if(sub) sub.textContent=money(cart.total_price);
    syncOffers(cart);
  }
  function syncOffers(cart){
    if(!drawer) return;
    var ids={}; cart.items.forEach(function(it){ ids[String(it.product_id)]=true; });
    drawer.querySelectorAll('[data-cart-offer]').forEach(function(card){ card.hidden=!!ids[card.getAttribute('data-product-id')]; });
    ['[data-cart-addon-group]','[data-cart-bundle-group]'].forEach(function(selector){
      var group=drawer.querySelector(selector); if(!group) return;
      group.hidden=!group.querySelector('[data-cart-offer]:not([hidden])');
    });
  }
  function refresh(cb){ fetch('/cart.js',{headers:{'Accept':'application/json'}}).then(function(r){return r.json();}).then(function(c){ render(c); if(cb)cb(c); }).catch(function(){}); }

  // Intercept product forms: "Add to cart" opens the drawer; "Buy now" (name=checkout) adds then goes straight to /checkout.
  document.addEventListener('submit',function(e){
    var form=e.target;
    if(!form.matches || !form.matches('form[action*="/cart/add"], form.jj-card__form, #pdp-form, #pdp-sticky-form')) return;
    var submitter=e.submitter;
    var toCheckout=!!(submitter && submitter.name==='checkout');
    e.preventDefault();
    var btn=submitter||form.querySelector('[name="add"]');
    var label=btn?btn.innerHTML:'';
    if(btn){ btn.disabled=true; btn.textContent=toCheckout?'…':'Adding…'; }
    fetch('/cart/add.js',{method:'POST',headers:{'Accept':'application/json'},body:new FormData(form)})
      .then(function(r){return r.json();})
      .then(function(){ if(toCheckout){ window.location.href='/checkout'; } else { refresh(function(){ openDrawer(); }); } })
      .catch(function(){ form.submit(); })
      .then(function(){ if(btn && !toCheckout){ setTimeout(function(){ btn.disabled=false; btn.innerHTML=label; },600); } });
  });

  // Remove or change a line without leaving the drawer.
  document.addEventListener('click',function(e){
    var rm=e.target.closest('[data-cart-remove]');
    var qty=e.target.closest('[data-cart-qty]');
    if(!rm&&!qty) return;
    e.preventDefault();
    var button=rm||qty;
    var key=rm?rm.getAttribute('data-cart-remove'):qty.getAttribute('data-cart-qty');
    var amount=rm?0:Math.max(0,(parseInt(qty.getAttribute('data-qty'),10)||0)+(parseInt(qty.getAttribute('data-delta'),10)||0));
    button.disabled=true;
    fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({id:key,quantity:amount})})
      .then(function(r){return r.json();}).then(render).catch(function(){ button.disabled=false; });
  });
})();

/* ==========================================================================
   WhatsApp live-chat panel — typing reveal, quick-reply chips, WA handoff.
   Open/close is handled by the generic [data-toggle] wiring above; this block
   adds the "live" behaviour: a typing indicator that resolves into the agent
   greeting the first time the panel opens, chips that prefill the message box,
   and a send action that opens wa.me with the typed text.
   ========================================================================== */
(function () {
  var chat = document.querySelector('[data-jj-chat]');
  if (!chat) return;
  var q  = function (s) { return chat.querySelector(s); };
  var qa = function (s) { return Array.prototype.slice.call(chat.querySelectorAll(s)); };
  var wa = (chat.getAttribute('data-wa') || '').replace(/[^0-9]/g, '');
  var typing = q('[data-jj-typing]');
  var reveal = q('[data-jj-reveal]');
  var input  = q('[data-jj-input]');
  var form   = q('[data-jj-send]');
  var callBtn = q('[data-jj-call]');
  var launchers = Array.prototype.slice.call(document.querySelectorAll('[data-toggle="#jj-chat"]'));
  var callNumber = (chat.getAttribute('data-call') || '').replace(/[^0-9+]/g, '');
  var revealed = false, timer = null;
  var fastOpen = window.matchMedia('(max-width: 820px)').matches;

  function doReveal() {
    if (revealed) return; revealed = true;
    timer = setTimeout(function () {
      if (typing) typing.style.display = 'none';
      if (reveal) reveal.hidden = false;
      if (input) { try { input.focus(); } catch (e) {} }
    }, fastOpen ? 260 : 650);
  }

  launchers.forEach(function (b) {
    b.addEventListener('click', function () {
      setTimeout(function () { if (chat.classList.contains('is-open')) doReveal(); }, 0);
    });
  });

  qa('[data-jj-fill]').forEach(function (c) {
    c.addEventListener('click', function () {
      if (!input) return;
      input.value = c.getAttribute('data-jj-fill') || '';
      input.focus();
    });
  });

  if (callBtn) {
    callBtn.addEventListener('click', function (e) {
      e.preventDefault();
      if (!callNumber) return;
      window.location.href = 'tel:' + callNumber;
    });
  }

  function send() {
    if (!wa) return;
    var msg = (input && input.value.trim()) || 'أهلاً، عايز أستفسر عن ألعاب JokeyJoy';
    window.open('https://wa.me/' + wa + '?text=' + encodeURIComponent(msg), '_blank', 'noopener');
  }
  if (form) form.addEventListener('submit', function (e) { e.preventDefault(); send(); });
})();
